<template lang="html">

  <article class="observacion">
    <div class="container-actions-buttons">
      <button title="Borrar observación" @click="showRemove = true">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </button>
      <button title="Editar observación" @click="showEdit = true">
        <i class="fa fa-pencil" aria-hidden="true"></i>
      </button>
    </div>
    <div class="cover-popup -recuperar row-center" v-if="showRemove">
      <div class="popup">
        <a class="cerrar -small" @click="showRemove = false">✕</a>
        <h2 class="text-center">¿Estás seguro de eliminar esta observación?</h2>
        <div class="container-buttons">
          <button class="btn -xs" @click="removeObservacion">Sí</button>
          <button class="btn -skull -xs" @click="showRemove = false">No</button>
        </div>
      </div>
    </div>
    <nueva-observacion @refresh="refresh" :dataObservacion="data" v-if="showEdit" @cancel="showEdit = false">
    </nueva-observacion>
    <template v-else>
      <p class="status" v-if="data.tipoObservacion">{{ data.tipoObservacion }}</p>
      <p class="fecha">{{ data.fecha }}</p>
      <h2 v-if="data.titulo">{{ data.titulo }}</h2>
      <p class="observacion-text" v-if="data.observacion" v-html="data.observacion"></p>
      <p class="observacion-text" v-if="data.texto" v-html="data.texto"></p>
      <arrow-link :text="'Ver Adjunto'" :external="true" :to="data.urlAdjunto" :blank="true"
        v-if="data.urlAdjunto"></arrow-link>
      <arrow-link :text="'Ver Adjunto'" :external="true" :to="data.urlArchivo" :blank="true"
        v-if="data.urlArchivo"></arrow-link>
    </template>

  </article>

</template>

<script lang="js">

import {
  mapActions
} from 'vuex';
import arrowlink from '@/components/parts/icons/arrow-link';
import nuevaobservacion from '@/components/parts/nueva-observacion';
export default {
  name: 'observacion-el',
  props: ['data'],
  components: {
    'arrow-link': arrowlink,
    'nueva-observacion': nuevaobservacion
  },
  mounted() {
    if (this.$route.params.status) {
      this.data.idItem = this.$route.params.status;
    }

    if (this.$route.params.id) {
      this.data.idItem = this.$route.params.id;
    }

  },
  data: () => ({
    dataObservacion: null,
    showEdit: false,
    showRemove: false

  }),
  methods: {
    ...mapActions(['eliminarObservacion']),
    refresh() {
      this.showEdit = false
      this.$emit('refresh');
    },
    removeObservacion() {

      this.eliminarObservacion({'idObservacion':this.data.idObservacion}).then(r => {
        if (r) {
          this.$emit('refresh');
          this.showRemove = false
        }
      })
     
    }
  },
}
</script>

<style scoped lang="scss">
.observacion {
  width: 100%;
  display: inline-block;
  text-align: left;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  position: relative;

  .fecha {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .status {
    font-size: 12px;
    text-transform: uppercase;
    display: inline-block;
    font-weight: 700;
    margin-bottom: 5px;

    &[type="rechazada"] {
      color: red;
    }
  }


  h2 {
    font-weight: bold;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    margin-bottom: 5px;
  }

  .observacion-text {
    font-size: 16px;
    width: 100%;
    text-align: left;
    margin-bottom: 5px;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  .container-actions-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
  }

  .container-actions-buttons button {
    border: 1px solid;
    padding: 2px;
    border-radius: 50%;
    margin-left: 5px;
    background: transparent;
    cursor: pointer;

    i {
      font-size: 15px;
    }
  }

  .container-buttons {
    display: flex;
    align-items: center;
    justify-self: center;

    button {
      cursor: pointer;
      background-color: rgb(214, 184, 84);
      color: rgb(255, 255, 255);
      border: 2px solid rgb(214, 184, 84);
      margin: 10px 5px 0 5px;

      &.-skull {
        color: rgb(0, 0, 0);
        border: 2px solid rgb(0, 0, 0);
        font-family: Nunito, sans-serif;
        background: white;
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/observacion-el.vue